export const GET_ALL_TIERS = `query($filter:AllerganProTierFilter){
    allAllerganProTiers(orderBy:ORDER_NO_ASC, filter:$filter) {
      nodes{
        id
        tierName
        country
        orderNo
        courseList: allerganProTierConfigurationsByTierId(orderBy: CREATED_AT_DESC) {
          nodes {
            id
            courseName
            courseId
          }
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
}`;

export const CREATE_TIER = `mutation($allerganProTier: AllerganProTierInput!){
    createAllerganProTier(input:{
      allerganProTier:$allerganProTier
    })
    {
      allerganProTier{
        id
      }
    }
}`;
export const UPDATE_TIER = `mutation {
	updateAllerganProTierById(input:{
		id: "e29bf642-7638-49e9-aa99-fd1486e44288",
		allerganProTierPatch: {
			tierName: "updated tier"
		}
	}) {
	allerganProTier {
		id
		tierName
	}}
}`;

export const GET_NEXT_ORDER = `query($country: String!) {
	allAllerganProTiers(orderBy:ORDER_NO_DESC,first:1,filter: { country: { equalTo: $country } }){
		nodes{
			orderNo
		}
	}
}`;

export const GET_ALL_COURSE_LIST = `query($filter: AllerganProTierConfigurationFilter){
    allAllerganProTierConfigurations(orderBy:CREATED_AT_DESC,filter:$filter){
      nodes{
        id
        tierId
        courseId
        courseName
        createdAt
        tierName: allerganProTierByTierId{
          tierName
        }
        orderNo: allerganProTierByTierId{
          orderNo
        }
      }
      totalCount
      pageInfo{
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }`;

export const ADD_COURSE = `mutation($allerganProTierConfiguration: AllerganProTierConfigurationInput!){
    createAllerganProTierConfiguration(input:{
      allerganProTierConfiguration: $allerganProTierConfiguration
    })
    {
      allerganProTierConfiguration{
        id
      }
    }
}`;

export const UPDATE_TIER_CONFIG = `mutation($id:UUID!,$allerganProTierConfigurationPatch: AllerganProTierConfigurationPatch!){
    updateAllerganProTierConfigurationById(input:{
      id:$id,
      allerganProTierConfigurationPatch:$allerganProTierConfigurationPatch
    })
    {
      allerganProTierByTierId{
        id
      }
    }
}`;

export const DELETE_COURSE = `mutation($id:UUID!) {
  deleteAllerganProTierById(input: { id: $id }) {
    clientMutationId
    deletedAllerganProTierId
  }
}`;

export const UPDATE_TIER_DETAILS = `mutation($id:UUID!, $tierName:String, $orderNo: Int) {
	updateAllerganProTierById(input:{
		id: $id,
		allerganProTierPatch: {
			tierName: $tierName
      orderNo: $orderNo
		}
	}) {
	allerganProTier {
		id
		tierName
	}}
}`;

export const DELETE_COURSE_FROM_TIER = `mutation($id:UUID!) {
  deleteAllerganProTierConfigurationById(input: { id: $id }) {
    clientMutationId
    allerganProTierConfiguration {
      id
    }
  }
}`;

export const GET_COURSE_IDS_FOR_COUNTRY = `query($country: String!) {
	allAllerganProTierConfigurations(filter: { allerganProTierByTierId: { country: { includesInsensitive: $country } }}) {
    nodes{
      courseId
    }
  }
}`;
